// The three session extensions sold at the venue POS. These are service time on
// a bay that is already running, so they are defined here rather than coming
// from the product catalogue — there is no stock and nothing to sync to Square.

export const SESSION_EXTENSIONS = [
  { key: 'track_15', name: '+15 Min Adult Extension', short: '+15m Adult Ext', badge: '+15m', price: 12, minutes: 15 },
  { key: 'overtime_30', name: '+30 Min Adult Extension', short: '+30m Adult Ext', badge: '+30m', price: 20, minutes: 30 },
  { key: 'junior_15', name: '+15 Min Junior Extension', short: '+15m Junior Ext', badge: '+15m', price: 8, minutes: 15 },
];

/** How an extension already bound to a bay reads in the order. */
export function extensionLineLabel(line) {
  return `Session Extension — ${line.bay_number || line.rig_name || 'Rig'} (+${line.minutes}m)`;
}

/** Whole minutes left on a running session, or null when there is no timer. */
export function minutesRemaining(expiresAt, nowMs = Date.now()) {
  if (!expiresAt) return null;
  const ms = new Date(expiresAt).getTime() - nowMs;
  if (!Number.isFinite(ms)) return null;
  return Math.max(0, Math.round(ms / 60000));
}

export function formatRemaining(mins) {
  if (mins == null) return 'No timer';
  if (mins <= 0) return 'Ending now';
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return h > 0 ? `${h}h ${String(m).padStart(2, '0')}m left` : `${m}m left`;
}

export function extensionsTotal(lines = []) {
  return lines.reduce((s, l) => s + (Number(l.price) || 0) * (Number(l.qty) || 1), 0);
}